import type { SetThemeAction, SetThemeSuccessAction } from "domains/theme/actionTypes";
import { ThemeType } from "domains/theme/actionTypes";
import type { Theme } from "domains/theme/types";

export const setTheme = (theme: Theme): SetThemeAction => ({ theme, type: ThemeType.SET });
export const setThemeSuccess = (theme: Theme): SetThemeSuccessAction => ({ theme, type: ThemeType.SET_SUCCESS });
